import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {RestorePasswordService} from '../../lib/services/restore-password/restore-password.service';
import {UserBlockedService} from "../../lib/services/user-blocked/user-blocked-service.service";
import {ToastService} from "../../lib/services/toast/toast.service";

@Component({
    selector: 'lib-restore-password',
    templateUrl: './validate-data.component.html',
    styleUrls: ['./validate-data.component.scss']
})
export class ValidateDataComponent implements OnInit, AfterViewInit {
    formDataUser: FormGroup;
    dataUser: boolean = true;
    formDataUserValid: boolean = false;
    validating: boolean = false;
    nameowner: string = "";
    numberAcount: string = "";
    serialToken: string = "";
    email: string = "";
    nameUser: string = "";
    showtipsToken: boolean = false;
    errorMessage = 'Uno o mas datos no corresponden con la informacion proporcionada. Revisa tu informacion';
    errorCodeIntroduced = false;
    validCode = false;
    codeIntroduced = ""
    resendingToken = false;
    temporalToken;
    validatingCode = false;
    validationDataSuccess = false;
    step = 'VALIDATE_DATA'
    titleError: string = 'Datos incorrectos';

    constructor(
        private restorePaswordservice: RestorePasswordService,
        public userBlockedService: UserBlockedService,
        public fb: FormBuilder,
        private toastService: ToastService,
    ) {
        this.formDataUser = this.fb.group({
            titularName: ['', [Validators.required]],
            noContrato: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(7)]],
            correoElectronico: ['', [Validators.required, Validators.email]],
            nomUsuario: ['', [Validators.required]],
        });

    }

    closeModal() {
        this.restorePaswordservice.close()
        this.validatingCode = false
    }

    showFormDataUser() {
        if (this.step === 'VALIDATE_DATA') {
            this.dataUser = true;
            this.formDataUserValid = false;
        } else if (this.step === 'VALIDATE_CODE') {
            this.validating = false;
            this.dataUser = false;
            this.formDataUserValid = true;
            this.validatingCode = false
            this.validCode = false;
        }
    }

    showTipsToken() {
        if (this.showtipsToken == false) {
            this.showtipsToken = true;
        } else {
            this.showtipsToken = false;
        }
    }

    validateDataForm() {
        this.validating = true;
        this.nameowner = this.formDataUser.getRawValue().titularName;
        this.numberAcount = this.formDataUser.getRawValue().noContrato;
        this.serialToken = this.formDataUser.getRawValue().noSerie;
        this.email = this.formDataUser.getRawValue().correoElectronico;
        this.nameUser = this.formDataUser.getRawValue().nomUsuario;
        this.restorePaswordservice.validateData(this.nameowner, this.numberAcount, this.email, this.nameUser).subscribe({
            next: value => {
                if (value.message) {
                    this.validating = false;
                    this.dataUser = false;
                    this.formDataUserValid = true;
                    this.step = 'VALIDATE_CODE'
                    this.temporalToken = value?.authorizationResetPass
                } else {
                    this.handlerError()
                    this.errorMessage = 'UNKNOWN_ERROR'
                }
            },
            error: err => {
                const errorCode = err?.error?.errorCode;
                if (errorCode) {
                    if (errorCode === 'RESET_PASSWORD_VALIDATE_DATA_ERROR') {
                        this.handlerError();
                    } else if (errorCode === 'USR06') {
                        this.validating = false;
                        this.closeModal();
                        this.userBlockedService.open(this.userBlockedService.getTranslations());
                    } else {
                        this.handlerError()
                        this.errorMessage = 'UNKNOWN_ERROR'
                    }
                } else {
                    this.handlerError()
                    this.errorMessage = 'UNKNOWN_ERROR'
                }
            }
        })
    }

    handlerError() {
        this.validating = false;
        this.dataUser = false;
        this.formDataUserValid = false;
    }

    ngOnInit() {
    }

    onCodeChanged(event: any) {
        this.errorCodeIntroduced = false
        if (!event || event.length < 6) {
            this.validCode = false;
        }
    }

    onCodeCompleted(event: any) {
        this.validCode = true;
        this.codeIntroduced = event;
    }

    ngAfterViewInit() {
        // this.validationTokenModal = true;
    }

    resendToken() {
        this.resendingToken = true;
        this.restorePaswordservice.resendToken(this.temporalToken).subscribe({
            next: value => {
                this.toastService.showToast("Códgo reenviado", "success", "", "resetPassword")
            }, error: err => {
                this.toastService.showToast("Error al reenviar código", "error", "", "resetPassword")
            },
            complete: () => {
                this.resendingToken = false;
            }
        })
    }

    validateOtpResetPassword() {
        this.validatingCode = true
        this.restorePaswordservice.validateOtpResetPassword(this.temporalToken, this.codeIntroduced).subscribe({
            next: value => {
                this.validationDataSuccess = true;
            },
            error: err => {
                console.log('Error?', err)
                const errorCode = err?.error?.errorCode;
                if (errorCode && errorCode === "UPDATE_PASSWORD_ERROR_SEND_EMAIL") {
                    this.handlerError();
                } else if (errorCode && errorCode === "UPDATE_PASSWORD_INVALID_CODE") {
                    this.handlerError();
                    this.titleError = 'resetPassword.invalidCode'
                    this.errorMessage = ''
                } else if (errorCode === 'USR06') {
                    this.validating = false;
                    this.closeModal();
                    this.userBlockedService.open(this.userBlockedService.getTranslations());
                } else {
                    this.handlerError()
                    this.errorMessage = 'UNKNOWN_ERROR'
                }
            },
            complete: () => {
                this.validatingCode = false;
            }
        })
    }

}
